import { fabric } from "sunzi-fabric";
import clonedeep from "lodash.clonedeep";
import {
  loadImageFromURL,
  loadFont,
  hsv2rgb,
  rgb2hsv,
  base64ToBlob,
  sceenGt768,
} from "@/utils";
import { RGB } from "@/sunzi";
import { ImageData } from "./new-sock";
import { urlToBlob } from "@sunzi/utils";

/** 根据用户的扣头生成头像 */
export const createAvatar = (avatar: string, color: RGB) =>
  new Promise<string>(async (resolve) => {
    const element = document.createElement("canvas");
    const canvas = new fabric.Canvas(element);
    canvas.setDimensions({
      width: 500,
      height: 500,
    });
    const avatarBlobURL = URL.createObjectURL(await urlToBlob(avatar));
    const avatarImage = await loadImageFromURL(avatarBlobURL);
    URL.revokeObjectURL(avatarBlobURL);
    // 头像宽高
    const avatarWidth = 350;
    const avatarHeight = 350;
    canvas.setBackgroundColor(`rgb(${color.r}, ${color.g}, ${color.b})`, () => {
      const scale = Math.min(
        avatarWidth / (avatarImage.width || 0),
        avatarHeight / (avatarImage.height || 0),
      );
      avatarImage.set({
        left: 250,
        top: 250,
        originX: "center",
        originY: "center",
        scaleX: scale,
        scaleY: scale,
      });
      canvas.add(avatarImage);
      canvas.renderAll();
      const result = canvas.toDataURL({ format: "png" });
      resolve(result);
      canvas.dispose();
      element.width = element.height = 0;
    });
  });

/** 根据用户的扣头生成壁纸 */
export const createWallpaper = (
  avatar: string,
  color: RGB,
  option?: {
    imageWidth?: number;
    imageHeight?: number;
    avatarOpacity?: number;
  },
) =>
  new Promise<string>(async (resolve) => {
    const element = document.createElement("canvas");
    const canvas = new fabric.Canvas(element);
    let paperWidth = window.screen.width;
    let paperHeight = window.screen.height;
    if (sceenGt768) {
      if (paperWidth >= 1600) {
        paperWidth = 1600;
        paperHeight = 900;
      }
    } else {
      paperWidth = paperWidth * 2;
      paperHeight = paperHeight * 2;
    }
    // 图片宽高
    const imageWidth = option?.imageWidth || paperWidth;
    const imageHeigh = option?.imageHeight || paperHeight;
    // 头像宽高
    const avatarWidth = 110;
    const avatarHeight = 158;
    // 画多少行多少列
    const rows = Math.ceil(imageHeigh / avatarHeight) + 1;
    const cols = Math.round(imageWidth / avatarWidth);
    // 头像间距
    const space = (imageWidth / (cols - 1)) * 2;
    // if (sceenGt768) {
    //   space *= 2;
    // }
    canvas.setDimensions({
      width: imageWidth,
      height: imageHeigh,
    });
    const avatarBlobURL = URL.createObjectURL(await urlToBlob(avatar));
    const avatarImage = await loadImageFromURL(avatarBlobURL);
    URL.revokeObjectURL(avatarBlobURL);
    canvas.setBackgroundColor(`rgb(${color.r}, ${color.g}, ${color.b})`, () => {
      const scale = Math.min(
        avatarWidth / (avatarImage.width || 0),
        avatarHeight / (avatarImage.height || 0),
      );
      for (let row = 0; row < rows; row++) {
        // 如果是偶数就少画一个头，奇数就画正常数量的头
        let drawCols = cols;
        let x = 0;
        let y = row * avatarHeight;
        if (row % 2 === 0) {
          drawCols = cols - 1;
          // 偶数行的因为少画一个头，所以有一个初始间距
          x += space / 2;
        }
        for (let col = 0; col < drawCols; col++) {
          const drawX = x + col * space;
          const image = clonedeep(avatarImage);
          image.set({
            left: drawX,
            top: y,
            scaleX: scale,
            scaleY: scale,
            originX: "center",
            originY: "center",
            opacity: option?.avatarOpacity || 1,
          });
          canvas.add(image);
        }
      }
      canvas.renderAll();
      const result = canvas.toDataURL({ format: "png" });
      resolve(result);
      canvas.dispose();
      element.height = element.width = 0;
    });
  });

/** 加载 svg 图片 */
const _loadSVGFromURL = (url: string) =>
  new Promise<fabric.Object>((resolve) => {
    fabric.loadSVGFromURL(url, (object) => {
      resolve(fabric.util.groupSVGElements(object));
    });
  });

/** 范围随机数 */
const _randomBetween = (start: number, end: number) => {
  const n = Math.random() * (end - start + 1);
  return Math.floor(n + start);
};

/** 生成分享图 */
// export const createShare = (avatar: ImageData, sock: string, color: RGB) => new Promise<string>(async resolve => {
//   const element = document.createElement('canvas');
//   const canvas = new fabric.Canvas(element);
//   canvas.setDimensions({
//     width: 800,
//     height: 450,
//   });
//   // 背景色是模型背景色的色相旋转 -90 度
//   const hsv = rgb2hsv(color.r, color.g, color.b);
//   hsv.h = (360 + hsv.h - 140) % 360;
//   hsv.s = 100;
//   hsv.v = 100;
//   const { r, g, b } = hsv2rgb(hsv.h, hsv.s, hsv.v);
//   const invertColor: RGB = { r, g, b };
//   const avatarBlobURL = URL.createObjectURL(base64ToBlob(avatar.origin));
//   const [ originImage, likeImage, sockImage, backgroundImage ] = await Promise.all([
//     loadImageFromURL(avatarBlobURL),
//     _loadSVGFromURL(require('@/assets/new-sock/like.svg')),
//     loadImageFromURL(sock),
//     createWallpaper(avatar.image, invertColor, {
//       imageWidth: 800,
//       imageHeight: 450,
//       avatarOpacity: 0.2,
//     }),
//   ]);
//   URL.revokeObjectURL(avatarBlobURL);
//   try {
//     await loadFont('roboto', 6000);
//   } catch(e) {
//     console.error('roboto 字体加载超时');
//   }
//   // 用户上传原图参数
//   const originImageWidth = 193;
//   const originImageHeight = 236;
//   const originImageLeft = 92;
//   const originImageTop = 107;
//   // 点赞图片宽高
//   const likeImageWidth = 119;
//   const likeImageHeight = 67;
//   const likeImageLeft = 206;
//   const likeImageTop = 61;
//   // 袜子图片宽高
//   const sockImageWidth = 800;
//   const sockImageHeight = 800;
//   const sockImageLeft = 180;
//   const sockImageTop = 225;
//   canvas.setBackgroundImage(backgroundImage, () => {
//     // 上传原图
//     const originScale = Math.min(
//       originImageWidth / (originImage.width || 0),
//       originImageHeight / (originImage.height || 0),
//     );
//     originImage.set({
//       left: originImageLeft + originImageWidth / 2,
//       top: originImageTop + originImageHeight / 2,
//       angle: -10,
//       scaleX: originScale,
//       scaleY: originScale,
//       originX: 'center',
//       originY: 'center',
//       stroke: '#fff',
//       strokeWidth: 15,
//     });
//     canvas.add(originImage);
//     // 点赞图片
//     const likeScale = Math.min(
//       likeImageWidth / (likeImage.width || 0),
//       likeImageHeight / (likeImage.height || 0),
//     );
//     likeImage.set({
//       left: likeImageLeft + likeImageWidth / 2,
//       top: likeImageTop + likeImageHeight / 2,
//       originX: 'center',
//       originY: 'center',
//     });
//     const likeNumber = _randomBetween(600, 999);
//     const text = new fabric.Text(likeNumber.toString(), {
//       fontFamily: 'roboto',
//       fontSize: 11,
//       fill: '#fff',
//       left: likeImageLeft + likeImageWidth / 2 + 7,
//       top: likeImageTop + likeImageHeight / 2 - 1,
//       originX: 'center',
//       originY: 'center',
//     });
//     const likeImageGroup = new fabric.Group([
//       likeImage,
//       text,
//     ], {
//       originX: 'center',
//       originY: 'center',
//       angle: 30,
//       scaleX: likeScale,
//       scaleY: likeScale,
//     });
//     canvas.add(likeImageGroup);
//     // 袜子图片
//     const sockScale = Math.min(
//       sockImageWidth / (sockImage.width || 0),
//       sockImageHeight / (sockImage.height || 0),
//     );
//     sockImage.set({
//       left: sockImageLeft + sockImageWidth / 2,
//       top: sockImageTop,
//       scaleX: sockScale,
//       scaleY: sockScale,
//       originX: 'center',
//       originY: 'center',
//     });
//     canvas.add(sockImage);
//     canvas.renderAll();
//     const result = canvas.toDataURL({ format: 'png' });
//     resolve(result);
//     canvas.dispose();
//   });
// });

/** 生成分享图 */
export const createShare = async (avatar: ImageData, sockColor: string) => {
  const element = document.createElement("canvas");
  const canvas = new fabric.Canvas(element);
  canvas.setDimensions({
    width: 800,
    height: 450,
  });
  // 加载图片
  const originBlobURL = URL.createObjectURL(base64ToBlob(avatar.origin));
  const avatarBlobURL = URL.createObjectURL(base64ToBlob(avatar.image));
  const shareBlobURL = URL.createObjectURL(
    base64ToBlob(require("@/assets/new-sock/share.png")),
  );
  const [originImage, avatarImage, sockBackgroundColor, shareFilter] =
    await Promise.all([
      loadImageFromURL(originBlobURL),
      loadImageFromURL(avatarBlobURL),
      loadImageFromURL(sockColor),
      loadImageFromURL(shareBlobURL),
    ]);
  URL.revokeObjectURL(originBlobURL);
  URL.revokeObjectURL(avatarBlobURL);
  URL.revokeObjectURL(shareBlobURL);
  // 用户上传原图参数
  const originWidth = 400;
  const originHeight = 450;
  const originScale = Math.max(
    originWidth / (originImage.width as number),
    originHeight / (originImage.height as number),
  );
  // 画用户上传原图
  originImage.set({
    left: originWidth / 2,
    top: originHeight / 2,
    originX: "center",
    originY: "center",
    scaleX: originScale,
    scaleY: originScale,
  });
  canvas.add(originImage);
  // 背景图参数
  const sockBackGroundWidth = 400;
  const sockBackGroundHeight = 450;
  // 画背景色
  sockBackgroundColor.set({
    left: 400,
    top: 0,
  });
  sockBackgroundColor.scaleToHeight(sockBackGroundHeight);
  sockBackgroundColor.scaleToWidth(sockBackGroundWidth);
  canvas.add(sockBackgroundColor);
  // 裁剪头像数据
  const avatarWidth = 78;
  const avatarHeight = 90;
  const avatarScale = Math.min(
    avatarWidth / (avatarImage.width || 0),
    avatarHeight / (avatarImage.height || 0),
  );
  // 第一个头像坐标
  const avatarLeft = 570;
  const avatarTop = 135;
  // 裁剪后图片
  for (let i = 0; i < 4; i++) {
    const image = clonedeep(avatarImage);
    let left = avatarLeft;
    let top = avatarTop + i * avatarHeight;
    if (i % 2 !== 0) {
      left += avatarWidth;
    }
    image.set({
      left: left,
      top: top,
      scaleX: avatarScale,
      scaleY: avatarScale,
      originX: "center",
      originY: "center",
    });
    canvas.add(image);
  }
  // 分享遮罩
  shareFilter.set({
    left: 0,
    top: 0,
  });
  canvas.add(shareFilter);
  canvas.renderAll();
  const result = canvas.toDataURL({ format: "png" });
  return result;
};
